import { ReactNode } from 'react';

interface Props {
  icon: ReactNode;
  title: string;
}

export const IconWithTitle = ({ title, icon }: Props) => {
  return (
    <div className="flex gap-3 items-center">
      <div className="icon-lg">{icon}</div>
      <p className="text-sm font-medium" data-qa="profile-wallet-title">
        {title}
      </p>
    </div>
  );
};
